import React, { useState } from 'react';
import PickerList from '../components/PickerList';
import { LANGUAGES } from '../data/languages';

const MobileLanguage = () => {
  const [selected, setSelected] = useState(localStorage.getItem('language') || '');

  return <PickerList options={LANGUAGES} selected={selected} onSelect={setSelected} />;
};

export default MobileLanguage;
